import { Action } from '@ngrx/store';
import { DatesIntervalRequest, DatesInterval } from '../../global/interfaces';
import { EsgDataResponse, EsgRequestPayload } from './esg.models';

export enum ActionTypes {
    LOAD_ESG_DATES = '[ESG] Load ESG Dates Action',
    LOAD_ESG_DATES_SUCCESS = '[ESG] Load ESG Dates Success Action',
    LOAD_ESG_DATES_FAILED = '[ESG] Load ESG Dates Failed Action',
    SET_ESG_YEAR_FILTER = '[ESG] Set ESG Year Filter Action',
    SET_ESG_MONTH_FILTER = '[ESG] Set ESG Month Filter Action',
    LOAD_ESG = '[ESG] Load ESG Data Action',
    LOAD_ESG_SUCCESS = '[ESG] Load ESG Data Success Action',
    LOAD_ESG_FAILED = '[ESG] Load ESG Data Fail Action',
    RESET_ESG_DATA = '[ESG] Reset ESG Data Action',
    SET_ESG_SORT = '[ESG] Sort ESG Data Action',
    ESG_FILE_DOWNLOAD_ACTION = '[ESG] File Download Action'
}


export class LoadEsgsDatesAction implements Action {
    readonly type = ActionTypes.LOAD_ESG_DATES;
    public constructor(public payload: DatesIntervalRequest) {
    }
}

export class LoadEsgDatesSuccessAction implements Action {
    readonly type = ActionTypes.LOAD_ESG_DATES_SUCCESS;
    public constructor(public payload: DatesInterval) {
    }
}

export class LoadEsgDatesFailedAction implements Action {
    readonly type = ActionTypes.LOAD_ESG_DATES_FAILED;
    public constructor(public payload: any) {
    }
}

export class ResetEsgDataAction implements Action {
    readonly type = ActionTypes.RESET_ESG_DATA;
}


export class SetEsgYearFilterAction implements Action {
    readonly type = ActionTypes.SET_ESG_YEAR_FILTER;
    public constructor(public payload: number) {
    }
}

export class SetEsgMonthFilterAction implements Action {
    readonly type = ActionTypes.SET_ESG_MONTH_FILTER;
    public constructor(public payload: number) {
    }
}


export class LoadEsgAction implements Action {
    readonly type = ActionTypes.LOAD_ESG;
    public constructor(public payload: EsgRequestPayload) {
    }
}

export class LoadEsgSuccessAction implements Action {
    readonly type = ActionTypes.LOAD_ESG_SUCCESS;
    public constructor(public payload: EsgDataResponse) {
    }
}

export class LoadEsgFailedAction implements Action {
    readonly type = ActionTypes.LOAD_ESG_FAILED;
    public constructor(public payload: any) {
    }
}

export class SetEsgSortAction implements Action {
    readonly type = ActionTypes.SET_ESG_SORT;
    public constructor(public payload: any) {
    }
}

export class EsgFileDownloadAction implements Action {
    readonly type = ActionTypes.ESG_FILE_DOWNLOAD_ACTION;
    public constructor(public payload: any) {
    }
}




export type Actions =
    LoadEsgsDatesAction |
    LoadEsgDatesSuccessAction |
    LoadEsgDatesFailedAction |
    ResetEsgDataAction |
    SetEsgYearFilterAction |
    SetEsgMonthFilterAction |
    LoadEsgAction |
    LoadEsgSuccessAction |
    LoadEsgFailedAction |
    SetEsgSortAction |
    EsgFileDownloadAction;
